import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasCheckboxComponent } from './checkbox/gas-checkbox.component';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasCheckboxGroupComponent } from './group/gas-checkbox-group.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GasFormKeyModule } from '../../utils/gas-form-key/gas-form-key.module';

const COMPONENTS = [
  GasCheckboxComponent,
  GasCheckboxGroupComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GasIconsModule,
    GasFormKeyModule,
  ],
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
})
export class GasCheckboxModule { }
